var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMore28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42855 18.8571C9.00651 18.8571 10.2857 17.578 10.2857 16C10.2857 14.422 9.00651 13.1429 7.42855 13.1429C5.8506 13.1429 4.57141 14.422 4.57141 16C4.57141 17.578 5.8506 18.8571 7.42855 18.8571ZM18.8571 16C18.8571 17.578 17.5779 18.8571 16 18.8571C14.422 18.8571 13.1428 17.578 13.1428 16C13.1428 14.422 14.422 13.1429 16 13.1429C17.5779 13.1429 18.8571 14.422 18.8571 16ZM27.4286 16C27.4286 17.578 26.1494 18.8571 24.5714 18.8571C22.9935 18.8571 21.7143 17.578 21.7143 16C21.7143 14.422 22.9935 13.1429 24.5714 13.1429C26.1494 13.1429 27.4286 14.422 27.4286 16Z",
    fill: "url(#paint0_linear_12038_13992)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12038_13992",
    x1: 4.57141,
    y1: 13.1429,
    x2: 7.26049,
    y2: 23.8992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore28);
export default __webpack_public_path__ + "static/media/more_28.a4e8fc78.svg";
export { ForwardRef as ReactComponent };